import { AUTH_BANNER_SHOW } from "./AuthBannerActionTypes";

export const showAuthBannerAction =
  (message: string, returnPath?: string | null) =>
  (dispatch: any) => {
    dispatch({
      type: AUTH_BANNER_SHOW,
      payload: {
        message,
        returnPath: returnPath ?? null,
      },
    });
  };
